<div class="grid">
  <img src="/assets/img/404.svg">

  <div>
    <ng-content></ng-content>
  </div>
</div>
